import { Box, Skeleton } from 'vopay';

// Localized loading placeholder rendered in place of a table while its data fetches
export default function TableSkeleton() {
  return (
    <Box flx="col" gapSize="12px" width="100%" mt="lg">
      <Skeleton height="40px" />
      <Skeleton height="40px" />
      <Skeleton height="40px" />
    </Box>
  );
}
